import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiInputNumberComponent } from './eui-input-number.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiInputNumberComponent,
    ],
    exports: [
        EuiInputNumberComponent,
    ],
})
export class EuiInputNumberDirectiveModule { }
